import './style/main.css'
import Application from './javascript/Application.js'

window.application = new Application({
    $canvas: document.querySelector('.js-canvas'),
    useComposer: true
})
//这里这个弹框加载有bug，所以先隐藏了，使用js将其显示
document.querySelector(".threejs-journey").style.display = "block";
